import AdyenForm from './AdyenForm';
import PayPalButton from './PayPalButton';

export { AdyenForm as Adyen, PayPalButton as PayPal };


// WEBPACK FOOTER //
// ./src/components/GatewayComponent/index.tsx